// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"PageContainer_pageContainer__3G47R","footerContainerDiv":"PageContainer_footerContainerDiv__1gXbW"};